import { render, staticRenderFns } from "./OrderCardItem.vue?vue&type=template&id=855a0f84"
import script from "./OrderCardItem.vue?vue&type=script&lang=js"
export * from "./OrderCardItem.vue?vue&type=script&lang=js"
import style0 from "./OrderCardItem.vue?vue&type=style&index=0&id=855a0f84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports